import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Tittle as OurBlogPostTittle } from "./services";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CustomImg as OurBlogPostCustomImg } from "./services";
import { Link } from "react-router-dom";
import { get } from "../../helpers/api_helpers";
import { config } from "../../config/config";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const OurBlogPost = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    let mounted = true;

    const fetchBlogs = async () => {
      try {
        const res = await get("/blogs", { page: 1, page_count: 6 });
        const list = res?.result?.blogs || [];

        if (mounted) {
          setBlogs(list.filter((b) => b.status));
        }
      } catch {}
    };

    fetchBlogs();

    return () => {
      mounted = false;
    };
  }, []);

  const settings = {
    dots: true,
    arrows: true,
    infinite: blogs.length > 3, // ✅ prevent loop bugs
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    slidesToShow: 4,
    slidesToScroll: 1, // ✅ smoother UX
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  if (!blogs.length) return null;
  //   const dummyBlogs = Array(5).fill({
  //   blog_id: 1,
  //   title: "Sample Blog Title",
  //   image1: `https://hips.hearstapps.com/clv.h-cdn.co/assets/16/18/gettyimages-586890581.jpg?crop=0.668xw:1.00xh;0.219xw,0`,
  // });

  return (
    <section className="">
      <div className="common-container">
        <div className="section-content">
          {/* <CommonWrapper> */}
          {/* <Tittle>
        <h2>
          Our <span className="tittleBold">Blog Post</span>
        </h2>
      </Tittle> */}
          <Tittle className="text-left">
            <h2 className="">
              Our <span className="tittleBold">Blog Post</span>
            </h2>
          </Tittle>

          <Container>
            <Slider {...settings}>
              {blogs?.length &&
                blogs.map((blog, index) => (
                  <SlideItem key={index}>
                    <StyledLink to={`/blog/${blog?.blog_id}`}>
                      <Image src={blog.image1} alt={blog.title} />
                      <BlogTitle>{blog.title}</BlogTitle>
                    </StyledLink>
                  </SlideItem>
                ))}
            </Slider>
          </Container>

          {/* <CustomImg>
        <img
          src={`${config.S3imgHostUrl}/frontend-assets/ourBlogPostCat.png`}
          alt="decorative"
        />
      </CustomImg> */}
          {/* </CommonWrapper> */}
        </div>
      </div>
    </section>
  );
};

export default OurBlogPost;

const SlideItem = styled.div`
  padding: 0 10px;
  box-sizing: border-box;
`;

const StyledLink = styled(Link)`
  display: block;
  text-decoration: none;
`;

const Image = styled.img`
  width: 100%;
  height: 320px;
  object-fit: cover;
  display: block;
  border-radius: 10px;
`;

// const BlogTitle = styled.p`
//   text-align: center;
//   font-size: 14px;
//   font-weight: bold;
//   color: #333;
//   margin-top: 8px;
//   padding: 0 8px;

// `;

const BlogTitle = styled.p`
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  color: #212529;
  text-align: center;
  margin-top: 8px;
  padding: 0 8px;
  line-height: 1.2;
`;

const Tittle = styled(OurBlogPostTittle)`
  position: relative;
  top: 3rem;
  z-index: 9;

  @media only screen and (max-width: 576px) {
    top: -45px;
  }
`;

const CustomImg = styled(OurBlogPostCustomImg)`
  right: 0;
  bottom: -17%;
  width: 24%;

  @media only screen and (max-width: 576px) {
    top: -90px;
    width: 44%;
    opacity: 0.5;
  }
`;

const Container = styled.div`
  width: 100%;
  position: relative;

  .slick-slider {
    width: 100%;
    padding: 20px;
  }

  .slick-list {
    margin: 0 -10px;
  }

  .slick-track {
    display: flex !important;
    align-items: stretch;
  }

  .slick-slide > div {
    height: 100%;
  }

  /* DOTS STYLING */
  .slick-dots {
    bottom: 0px;
  }

  .slick-dots li button:before {
    display: none;
  }

  .slick-dots li button {
    width: 12px;
    height: 12px;
    background: #e4e4e4;
    border-radius: 50%;
  }

  .slick-dots .slick-active button {
    background: #00419d;
  }
`;

export const CommonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;
